// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root___zR2F","title":"Info_title__3LFdj","selects":"Info_selects__3OTad","requiredAsterisk":"Info_requiredAsterisk__1zG5N"};